import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class ControlSharedService {
  api = environment.SERVER_URL + 'icrweb/home/'
  constructor(
    private http: HttpClient
  ) { }

  getAudioFile(params) {
    return this.http.get(this.api + 'read_audo_file', {
      params: params
    })
  }
  getCallLogs(request) {
    return this.http.post(this.api + "get_call_log_list", request, {
      headers: {
        header_type: '2'
      }
    });
  }
  getPrimarySkills(request) {
    return this.http.post(this.api + 'searchSkill', request, {
      headers: { header_type: '2' }
    })
  }

}
